import * as React from "react";
import type { SVGProps } from "react";
const SvgCardEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.501 15.66h-1zm0-9h1zm10.2 12.4a1 1 0 0 0 0-2v2m-7.8-1v-1zM20.7 6.659h-1zm-18.6.8a1 1 0 0 0 0 2v-2m18 2a1 1 0 1 0 0-2v2m-4.802 7.4-.707-.706a1 1 0 0 0-.293.707zm4.32-4.32.707-.706a1 1 0 0 0-1.414 0zm2.88 2.88.707.708a1 1 0 0 0 0-1.414zm-4.32 4.32v1a1 1 0 0 0 .707-.292zm-2.88 0h-1a1 1 0 0 0 1 1zM3.901 4.26v1H18.3v-2H3.9zm-2.4 11.4h1v-9h-2v9zm10.2 2.4v-1H3.9v2h7.8zm9-11.401h-1V9.06h2V6.66zM3.9 4.26v-1a3.4 3.4 0 0 0-3.4 3.4h2a1.4 1.4 0 0 1 1.4-1.4zm14.399 0v1a1.4 1.4 0 0 1 1.4 1.399h2a3.4 3.4 0 0 0-3.4-3.399zM1.501 15.66h-1a3.4 3.4 0 0 0 3.4 3.4v-2a1.4 1.4 0 0 1-1.4-1.4zm.6-7.2v1h18v-2h-18zm13.198 8.4.707.707 4.32-4.32-.707-.707-.707-.707-4.32 4.32zm4.32-4.32-.707.707 2.88 2.88.707-.707.707-.707-2.88-2.88zm2.88 2.88-.707-.707-4.32 4.32.707.707.707.707 4.32-4.32zm-4.32 4.32v-1H15.3v2h2.88zm-2.88 0h1v-2.88h-2v2.88z"
    />
  </svg>
);
export default SvgCardEdit;
